<script lang="ts" setup>
import { computed } from '#imports';
import { useService } from '@kaokei/use-vue-service';
import { UserService } from '@core/services/user.service';
import { ZoneService } from '@core/services/zone.service';
import { ZONE_OPTIONS } from '@core/utils/constant';

defineOptions({
  inheritAttrs: false,
});

const userService = useService(UserService);
const zoneService = useService(ZoneService);

const handleChange = (val: any) => {
  zoneService.updateZone(val);
};

const RENDER_OPTIONS = computed(() => {
  const myZone = userService.user?.myZone?.length
    ? userService.user.myZone
    : [zoneService.zone];
  return ZONE_OPTIONS.filter((item) => myZone.includes(item.value));
});
</script>

<template>
  <a-select
    v-bind="$attrs"
    :value="zoneService.zone"
    style="width: 90px"
    :options="RENDER_OPTIONS"
    @change="handleChange"
  />
</template>
